function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'blackpurple': 'rgb(121, 50, 168)','blackgreen': 'rgb(54, 143, 104)','blackblue': 'rgb(40, 74, 209)','blackdark-grey': 'rgb(60, 59, 61)','blackred': 'rgb(209, 40, 46)','blackrose': 'rgb(237, 185, 187)','blackyellow': 'rgb(242, 242, 44)','blackblack': 'rgb(0, 8, 10)','blacklight-grey': 'rgb(191, 197, 199)','rose-gold': 'rgb(237, 185, 187)','black-with-grey-sleeve': 'rgb(60, 59, 61)','rose-gold-with-grey-sleeve': 'rgb(237, 185, 187)','silver-with-grey-sleeve': 'rgb(191, 197, 199)','all-silver': 'rgb(191, 197, 199)','all-black': 'rgb(0, 8, 10)','all-rose-gold': 'rgb(237, 185, 187)','gunmetal': 'rgb(0, 8, 10)',};

    this.images = {'chrome': 'url("//thedartco.com/cdn/shop/files/Screenshot_2023-10-04_at_11.47.58_PM_68x.png?v=2702266806647327")','icy': 'url("//thedartco.com/cdn/shop/files/Screenshot_2023-10-04_at_11.48.49_PM_68x.png?v=9344292069623249972")','brushed': 'url("//thedartco.com/cdn/shop/files/Screenshot_2023-10-04_at_11.47.58_PM_68x.png?v=2702266806647327")','red-green-blue': 'url("//thedartco.com/cdn/shop/files/IMG_3033_68x.PNG?v=15182675879593212265")','purple-gold-rose-gold': 'url("//thedartco.com/cdn/shop/files/Screen_Shot_2021-10-22_at_9.55.42_PM_68x.png?v=10070632265023821773")',};

    this.triggers = ['color','colour','couleur','farbe','cor','set color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
